var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounterRedLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "75px",
    viewBox: "0 0 70 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "counter-red-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 35,
    cy: 35,
    r: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.9%",
    y: "-3.9%",
    width: "107.8%",
    height: "107.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "counter-red-large"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-41",
    fill: "#000000",
    cx: 35,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-42",
    fill: "#000000",
    cx: 35,
    cy: 40,
    r: 35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-43"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FD6687",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterRedLarge);
export default __webpack_public_path__ + "static/media/counter-red-large.660c2bf877150e5a3430479adf62bb45.svg";
export { ForwardRef as ReactComponent };